// src/components/PromoPopup.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PromoImage from "../assets/logo_qdriver.png";

const PromoPopup = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {

    setVisible(true);
  }, []);

  if (!visible) return null;

  const handleClose = () => setVisible(false);
  const handleClick = () => {
    navigate("/khoa-hoc");
    setVisible(false);
  };

  // Inline styles (có responsive tự nhiên)
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const popupStyle = {
    position: "relative",
    background: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    width: "90%",
    maxWidth: "400px", // Giới hạn kích thước tối đa
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
    display: "block",
    cursor: "pointer",
  };

  const closeBtnStyle = {
    position: "absolute",
    top: "8px",
    right: "10px",
    background: "rgba(0,0,0,0.4)",
    color: "white",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    lineHeight: "28px",
    textAlign: "center",
  };

  return (
    <div style={overlayStyle} onClick={handleClose}>
      <div style={popupStyle} onClick={(e) => e.stopPropagation()}>
        <button style={closeBtnStyle} onClick={handleClose}>
          &times;
        </button>
        <img
          src={PromoImage}
          alt="Giảm giá cuối năm"
          style={imageStyle}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default PromoPopup;
